import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Ellipsis extends BaseOption {
  static userInterfaceComponent = {
    label: "Ellipsis",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Yes",
          value: "Yes",
          tooltip: "",
        },
        {
          label: "No",
          value: "No",
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = "Yes";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue === "Yes";
  }
}
